export type TileBasePositionInput = {
  index: number;
  startX: number;
  startY: number;
  tileW: number;
  tileH: number;
  gap: number;
};

export type TileBasePosition = {
  x: number;
  y: number;
};

export type TileVisualSnapshot = {
  x: number;
  y: number;
  scale: number;
  baseX: number;
  baseY: number;
};

export type Key9TileVisualInput = {
  selected: boolean;
  used: boolean;
};

export type Key9TileVisualState = {
  selected: boolean;
  disabled: boolean;
  faded: boolean;
  doneMarker: boolean;
};

export function getTileBasePosition(input: TileBasePositionInput): TileBasePosition {
  return {
    x: input.startX + input.index * (input.tileW + input.gap) + input.tileW / 2,
    y: input.startY + input.tileH / 2
  };
}

export function resetTileVisualSnapshot(snapshot: TileVisualSnapshot): Pick<TileVisualSnapshot, 'x' | 'y' | 'scale'> {
  return {
    x: snapshot.baseX,
    y: snapshot.baseY,
    scale: 1
  };
}

export function resetTileVisualSnapshots(snapshots: TileVisualSnapshot[]): Pick<TileVisualSnapshot, 'x' | 'y' | 'scale'>[] {
  return snapshots.map(resetTileVisualSnapshot);
}

export function getKey9TileVisualState(input: Key9TileVisualInput): Key9TileVisualState {
  return {
    selected: input.selected && !input.used,
    disabled: input.used,
    faded: input.used,
    doneMarker: input.used
  };
}
